import { StatePrescriptionIdentification } from '../../enums/StatePrescriptionIdentification';
import { StatePrescription } from '../../models/StatePrescription';

export const prescriptionStates = [
    { id: StatePrescriptionIdentification.SemReceita, description: 'Sem Receita' },
    { id: StatePrescriptionIdentification.ReceitaPendente, description: 'Receita Pendente' },
    { id: StatePrescriptionIdentification.SolicitarLente, description: 'Solicitar Lente' },
    { id: StatePrescriptionIdentification.AguardandoLente, description: 'Aguardando Lente' },
    { id: StatePrescriptionIdentification.AguardandoMontagemInterna, description: 'Aguardando Montagem Interna' },
    { id: StatePrescriptionIdentification.AguardandoMontagemExterna, description: 'Aguardando Montagem Externa' },
    { id: StatePrescriptionIdentification.AguardandoConferencia, description: 'Aguardando Conferência' },
    { id: StatePrescriptionIdentification.Ok, description: 'Ok' }
];

export class StatesPrescriptionsService {

    get = (): StatePrescription[] => prescriptionStates;
}